module.exports = __webpack_public_path__ + "assets/fonts/EBGaramond-Regular.cc3fc1d1.ttf";